import { render, staticRenderFns } from "./startQuestModal.vue?vue&type=template&id=8c3466c8&scoped=true&"
import script from "./startQuestModal.vue?vue&type=script&lang=js&"
export * from "./startQuestModal.vue?vue&type=script&lang=js&"
import style0 from "./startQuestModal.vue?vue&type=style&index=0&id=8c3466c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3466c8",
  null
  
)

export default component.exports